
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import { logger } from '../../../logger';
import { SearchBoxMixin } from '../../mixins/search-box.mixin';

@Component
export default class ClientSearchBox extends Mixins(SearchBoxMixin) {

  @Prop()
  domInputSelector: string;

  render() {}

  mounted() {
    this.$x.on(EVENTS.RebindDomEvents).subscribe(this.onDomInputSelectorChange);
  }

  @Watch('domInputSelector', { immediate: true })
  onDomInputSelectorChange() {
    this.removePreviousListeners();
    this.selectDomElement();
    if (this.$refs.input) {
      this.emitEventIfFocused();
      this.addNewListeners();
    } else {
      logger.warn('[CLIENT_SEARCH_BOX]', `the client input search box is not found with selector: ${ this.domInputSelector }`);
    }
  }

  @Watch('value', { immediate: true })
  onValueChange(value: string) {
    this.updateClientInputValue(value);
  }

  selectDomElement() {
    this.$refs.input = document.querySelector<HTMLInputElement>(this.domInputSelector);
  }

  emitEventIfFocused() {
    if (this.$refs.input === document.activeElement) {
      this.onFocus();
    }
  }

  addNewListeners() {
    this.$refs.input.addEventListener('input', this.onInput);
    this.$refs.input.addEventListener('keydown', this.onKeydown);
    this.$refs.input.addEventListener('focus', this.onFocus);
    this.$refs.input.addEventListener('blur', this.onBlur);
    this.$refs.input.addEventListener('click', this.onClick);
  }

  removePreviousListeners() {
    if (this.$refs.input) {
      this.$refs.input.removeEventListener('input', this.onInput);
      this.$refs.input.removeEventListener('keydown', this.onKeydown);
      this.$refs.input.removeEventListener('focus', this.onFocus);
      this.$refs.input.removeEventListener('blur', this.onBlur);
      this.$refs.input.removeEventListener('click', this.onClick);
    }
  }

  updateClientInputValue(value: string) {
    if (this.$refs.input) {
      this.$refs.input.value = value;
    }
  }
}
